module.exports = __webpack_public_path__ + "img/one-finger-swipe-right.e61a75e7.svg";